var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDemolish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 26 26",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M6 2h2M6 3h2M4 4h2m2 0h4m4 0h2M4 5h2m2 0h4m4 0h2M6 6h4m2 0h4m2 0h2M6 7h4m2 0h4m2 0h2M8 8h2m4 0h4M8 9h2m4 0h4M6 10h2m6 0h2M6 11h2m6 0h2M4 12h2m10 0h2M4 13h2m10 0h2M2 14h2m12 0h2M2 15h2m12 0h2M2 16h2m12 0h2M2 17h2m12 0h2M2 18h2m10 0h2M2 19h2m10 0h2M4 20h2m6 0h2M4 21h2m6 0h2m-8 1h6m-6 1h6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#af0800",
    d: "M6 4h2M6 5h2m2 1h2m4 0h2m-8 1h2m4 0h2m-8 1h4m-4 1h4m-6 1h2m-2 1h2m-4 1h2m6 0h2M6 13h2m6 0h2M4 14h2m8 0h2M4 15h2m8 0h2M4 16h2m8 0h2M4 17h2m8 0h2M4 18h2m6 0h2M4 19h2m6 0h2m-8 1h2m2 0h2m-6 1h2m2 0h2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#f21c00",
    d: "M10 10h4m-4 1h4m-6 1h2m2 0h2m-6 1h2m2 0h2m-8 1h2m4 0h2m-8 1h2m4 0h2m-2 1h2m-2 1h2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff8300",
    d: "M10 12h2m-2 1h2m-2 1h2m-2 1h2m-6 3h2m-2 1h2m0 1h2m-2 1h2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff4c00",
    d: "M8 14h2m-2 1h2m-4 1h2m-2 1h2m2 1h2m-2 1h2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ffae00",
    d: "M8 16h4m-4 1h4m-4 1h2m-2 1h2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemolish);
export default __webpack_public_path__ + "static/media/demolish.72bab76001886d00d626d7bbafcbcc55.svg";
export { ForwardRef as ReactComponent };